import { render, staticRenderFns } from "./ac-resource.vue?vue&type=template&id=906030f0&scoped=true&"
import script from "./ac-resource.vue?vue&type=script&lang=js&"
export * from "./ac-resource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906030f0",
  null
  
)

export default component.exports